import React from 'react';

import { Button } from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { observer } from 'mobx-react';

import { PageTitle } from '../../../../shared/components/ui-components';
import { goTo } from '../../../../shared/utils/angularUtils';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { useCoachSeatsValidation } from '../../../../payment';
import { useUserRoleLabel } from '../../../../shared/hooks/useUserRoleLabel';

const SETUP_COACH_PATH = '/coach-setup';

const CoachListPageTitle = observer(() => {
  const { isSuperAdmin, paymentFlowType, getEntityId } = loggedInUserDataStore;
  const entityId = getEntityId();

  const { getForAgent } = useUserRoleLabel();

  const { handleAddCoachValidation } = useCoachSeatsValidation(entityId);

  const handleAddCoach = async () => {
    if (isSuperAdmin || !paymentFlowType.NEW_USER_FLOW_2024) {
      goTo(SETUP_COACH_PATH);
    } else {
      handleAddCoachValidation(() => goTo(SETUP_COACH_PATH));
    }
  };
  return (
    <PageTitle title={`${getForAgent()} List`}>
      <Button
        variant="contained"
        size="medium"
        startIcon={<AddRoundedIcon />}
        onClick={handleAddCoach}
      >
        Add a New {getForAgent()}
      </Button>
    </PageTitle>
  );
});

export { CoachListPageTitle };
